import { forwardRef } from "react";
import { useTranslation } from "react-i18next";

import { Button, ButtonProps } from "@/components/_atoms/button";
import { IconFilter } from "@/components/_icons/IconFilter";
import { cn } from "@/lib/cn";

type ToolbarFilterButtonProps = Omit<ButtonProps, "children">;

export const ToolbarFilterButton = forwardRef<HTMLButtonElement, ToolbarFilterButtonProps>(
  ({ className, ...props }, ref) => {
    const { t } = useTranslation("common");

    return (
      <Button
        ref={ref}
        variant="outline"
        size="xs"
        className={cn("font-normal", className)}
        aria-label={t("view.addFilter")}
        {...props}
      >
        <IconFilter className="mr-2 h-3.5 w-3.5 text-foreground/60" />
        {t("view.filterSingular")}
      </Button>
    );
  },
);

ToolbarFilterButton.displayName = "ToolbarFilterButton";
